import React from 'react';
import { useTranslation } from '../context/AppContext';
import { Link } from 'react-router-dom';

export default function Footer() {
    const { t } = useTranslation(); // ✅ Только useTranslation

  return (
    <footer className="py-8 px-6 bg-gray-900 text-gray-300 text-center">
      <p>{t.footer}</p>
      <p className="text-sm mt-2">{t.contact}</p>
      <p className="text-sm mt-4">
        <Link to="/privacy-policy" className="text-blue-400 hover:text-blue-300 underline">
          {t.privacyPolicyTitle}
        </Link>
      </p>
    </footer>
  );
}